<template>
  <span :title="title" class="svg-style">
    <svg aria-hidden="true" class="svg-icon" :style="`width: ${size};height: ${size};`">
      <use :xlink:href="symbolId" />
    </svg>
  </span>
</template>
<script>
export default {
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    color: {
      type: String,
      default: '#FFFFFF'
    },
    size: {
      type: String,
      default: '2em'
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    symbolId() {
      return `#${this.prefix}-${this.icon}`
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";

.svg-icon {
  overflow: hidden;
  fill: currentColor;
  stroke: currentColor;
}

.svg-style {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  svg {
    .handle-hover-color(@qa-primary-color);
  }
}
</style>
